/* eslint-disable arrow-body-style */
import {
  Backdrop,
  Button,
  Fade,
  Paper,
  Portal,
  styled,
} from '@material-ui/core';
import { WebSocketEventTarget } from '@src/logic/websocketconnector';
import { selectWebsocketState } from '@src/reducers/websocket';
import useDebouncedValue from '@src/utils/useDebouncedValue';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

const PaperStyled = styled(Paper)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '8px 16px',
  position: 'sticky',
  inset: '0 0 auto 0',
  zIndex: 1000,
  '& .description': {
    flex: 1,
    textAlign: 'center',
  },
});

const BlurBackdrop = styled(Backdrop)({
  backdropFilter: 'blur(4px)',
  position: 'fixed',
  inset: '0',
  background: '#00000020',
  zIndex: 999,
});

const ConnectionLostAlert: React.FC = () => {
  const { readyState } = useSelector(selectWebsocketState);

  const [delay, setDelay] = useState(5000);

  const [wsDisconected, setInmediateWsDisconnected] = useDebouncedValue(
    readyState === WebSocket.CLOSED || readyState === WebSocket.CONNECTING,
    delay
  );

  useEffect(() => {
    if (readyState === WebSocket.OPEN) {
      setInmediateWsDisconnected(false);
      setDelay(1000);
    }
  }, [readyState, setInmediateWsDisconnected]);

  return (
    <>
      <Fade in={wsDisconected} timeout={250} unmountOnExit>
        <PaperStyled>
          <span className="description">
            <FormattedMessage id="connection-lost-alert" />
          </span>
          <Fade in={readyState !== WebSocket.OPEN}>
            <Button
              className="reconnect"
              color="primary"
              size="small"
              variant="contained"
              onClick={() => {
                WebSocketEventTarget.dispatchEvent(new Event('reconnect'));
              }}
            >
              {readyState === WebSocket.CONNECTING ? (
                <FormattedMessage id="connecting" />
              ) : (
                <FormattedMessage id="reconnect" />
              )}
            </Button>
          </Fade>
        </PaperStyled>
      </Fade>
      <Portal>
        <BlurBackdrop open={wsDisconected} />
      </Portal>
    </>
  );
};

export default ConnectionLostAlert;
